/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, RootStateOrAny } from "react-redux";
import "./ServiceTypesContainer.less";
import moment from "moment";
import ServiceTypes from "../../components/ServiceTypes/ServiceTypes";
import { fetchServiceTypesAdmin, fetchTaxesRates } from "../../store/slices/service-types";
import { ServiceTypesProps } from "../../components/ServiceTypes/ServiceTypesInterfaces";
import {
  fetchChargeNameTypeStatus,
  fetchProducts,
  fetchServiceMode,
} from "../../store/slices/rtkDictionaries";
import { toHttpFormatStartOfDay } from "../../lib/utils/formatDate";

const ServiceTypesContainer: React.FC<ServiceTypesProps> = () => {
  const dispatch = useDispatch();
  const serviceTypesData = useSelector((state: RootStateOrAny) => state?.serviceTypes);
  const { serviceTypes, serviceTypesLoading } = serviceTypesData;
  const [findServiceTypesByDate, setFindServiceTypesByDate] = useState<boolean>(false);
  const [onDate, setOnDate] = useState<moment.Moment | null>(moment());

  const onChangeDate = (e) => {
    setOnDate(e);
  };

  const toggleServiceTypesByDate = () => {
    setFindServiceTypesByDate((prev) => !prev);
  };

  useEffect(() => {
    dispatch(fetchServiceMode());
    dispatch(fetchProducts());
    dispatch(fetchChargeNameTypeStatus());
    dispatch(fetchTaxesRates());
  }, []);

  useEffect(() => {
    dispatch(fetchServiceTypesAdmin(onDate ? toHttpFormatStartOfDay(onDate) : ""));
  }, [findServiceTypesByDate]);

  return (
    <>
      <div className="container_height">
        <ServiceTypes
          onDate={onDate}
          serviceTypes={serviceTypes}
          serviceTypesLoading={serviceTypesLoading}
          onChangeDate={onChangeDate}
          toggleServiceTypesByDate={toggleServiceTypesByDate}
        />
      </div>
    </>
  );
};

export default ServiceTypesContainer;
